import clsx from "clsx";
import { Children, type ReactNode } from "react";

import styles from "./PageMetaSection.module.css";

interface IPageMetaSection {
  /** Page-footer meta components, e.g. PageInformation, FeedbackBlock, PrintButton. */
  children: ReactNode;
  /** Optional extra class names merged onto the section wrapper. */
  className?: string;
}

/**
 * Local layout wrapper (inspired by Grid) that owns the vertical spacing
 * AROUND and BETWEEN the "page footer meta" components.
 *
 * Spacing is driven entirely by CSS `gap` + `padding-block`, so the wrapper only
 * contributes spacing for children that actually render: `gap` sits between
 * rendered flex items only, and `:empty` collapses the wrapper when every child
 * renders null. Falsy children passed directly are dropped up front so a parent
 * that conditionally omits a child never produces dangling space.
 */
export const PageMetaSection = ({ children, className }: IPageMetaSection) => {
  const renderedChildren = Children.toArray(children).filter(Boolean);

  if (renderedChildren.length === 0) {
    return null;
  }

  return <div className={clsx(styles.pageMetaSection, className)}>{renderedChildren}</div>;
};

export default PageMetaSection;
